import axios from '../services/axios';
import { createContext, useContext } from "react";

export const authContext = createContext(null);

export function AuthProvider({ children }) {
  const auth = useAuthProvider();
  return <authContext.Provider value={auth}>{children}</authContext.Provider>;
}

export const useAuth = () => useContext(authContext);

// Determine which storage to use based on login
export const getStorage = () => {
  return localStorage.getItem("token_storage") === "session"
    ? sessionStorage
    : localStorage;
};

// Login handler
export const login = async (
  username,
  password,
  stayLoggedIn
) => {
  const params = new URLSearchParams();
  params.append("grant_type", "password");
  params.append("username", username);
  params.append("password", password);
  params.append("scope", "openid offline_access");

  // Store the user's choice for later
  localStorage.setItem("token_storage", stayLoggedIn ? "local" : "session");

  const res = await axios.post(
    "https://em2w.azurewebsites.net/api/connect/token",
    params,
    {
      headers: { "Content-Type": "application/x-www-form-urlencoded" },
    }
  );

  const storage = stayLoggedIn ? localStorage : sessionStorage;

  storage.setItem("access_token", res.data.access_token);
  storage.setItem("refresh_token", res.data.refresh_token);
  storage.setItem("expires_in", res.data.expires_in);

  setRefreshTimeout(res.data.expires_in);
};

// Refresh token logic
export const refreshToken = function (reload = true) {
  const storage = getStorage();
  const refresh_token = storage.getItem("refresh_token");

  if (!refresh_token) {
    logout();
    return;
  }

  const params = new URLSearchParams();
  params.append("grant_type", "refresh_token");
  params.append("refresh_token", refresh_token);

  axios
    .post("https://em2w.azurewebsites.net/api/connect/token", params, {
      headers: { "Content-Type": "application/x-www-form-urlencoded" },
    })
    .then((res) => {
      storage.setItem("access_token", res.data.access_token);
      axios.defaults.headers.common["Authorization"] = res.data.access_token;
      setRefreshTimeout(res.data.expires_in);
      if (reload) {console.log("Token refreshed.");}

    })
    .catch((err) => {
      console.error(err);
      logout();
    });
};

// Auto-refresh before token expires
export const setRefreshTimeout = function (seconds) {
  setTimeout(() => refreshToken(true), seconds * 900); // ~15% early
};

// Logout user
export const logout = () => {
  const storage = getStorage();
  storage.removeItem("access_token");
  storage.removeItem("refresh_token");
  localStorage.removeItem("token_storage");
  localStorage.removeItem("user");
  localStorage.removeItem("access_token");
  localStorage.removeItem("msal.account.keys");
  localStorage.removeItem("msal.token.keys.16654fb0-e899-48f4-b82b-dccb140017c3");
  localStorage.removeItem("msal.version");
  localStorage.removeItem("environment");
  localStorage.removeItem("token_storage");
  window.location.href = "/";
};

// Utility getter
export const getCurrentToken = () => {
  return getStorage().getItem("refresh_token");
};

// Placeholder for future expansion (user profile, auth state, etc.)
const useAuthProvider = () => {
  return {};
};
